export default "__VITE_ASSET__BTxdG_q7__"